import React from "react";
import { Header } from "./Header";
import { HEADER_HEIGHT } from "@/config/data";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <div className="flex flex-1" style={{ paddingTop: HEADER_HEIGHT }}>
        <main className="flex-1 flex flex-col">{children}</main>
      </div>
    </div>
  );
};
